import { render, staticRenderFns } from "./goal-status-icon.vue?vue&type=template&id=78835bd7&"
import script from "./goal-status-icon.vue?vue&type=script&lang=js&"
export * from "./goal-status-icon.vue?vue&type=script&lang=js&"
import style0 from "./goal-status-icon.vue?vue&type=style&index=0&id=78835bd7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports